import { connect } from 'react-redux';
import {
  compose,
  lifecycle,
  setDisplayName,
  withHandlers,
  withState,
} from 'recompose';
import { bindActionCreators } from 'redux';
import { appAction, salesAction, usersAction } from '@/actions';
import { getShopOnboardingLink } from '@/apis';
import notify from '@/migration/notification';

const mapStateToProps = (state) => ({
  sales: state.sales.toJS(),
  users: state.users.toJS(),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...salesAction, ...appAction, ...usersAction },
    dispatch
  );

const notifyError = (message) => notify(message, 'error', undefined, 5);

const enhance = compose(
  setDisplayName('BankAccount'),
  withState('pageOfItems', 'pageOfItemsUpdater', []),
  withState('isLoading', 'isLoadingUpdater', false),
  withState('open', 'toggleModal', false),
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onChangePage: (props) => (pageOfItems) => {
      const { pageOfItemsUpdater } = props;

      pageOfItemsUpdater(pageOfItems);
    },

    // 未登録のユーザーが口座登録を開始する。
    // サーバー側で Express アカウントを作成し、オンボーディングURLが返る。
    handleConnectStripe: (props) => async () => {
      const { putUserShop, isLoadingUpdater } = props;
      const userId = props.users.mydata.id;

      isLoadingUpdater(true);
      try {
        const result = await putUserShop(userId);
        const url = result && result.value && result.value.onboarding_url;

        if (!url) {
          notifyError(
            '口座登録の開始に失敗しました。時間をおいて再度お試しください'
          );
          return;
        }

        window.location.href = url;
      } catch (error) {
        notifyError(
          '口座登録の開始に失敗しました。時間をおいて再度お試しください'
        );
      } finally {
        isLoadingUpdater(false);
      }
    },

    // オンボーディングを途中で離脱したユーザーが続きから再開する。
    handleResumeOnboarding: (props) => async () => {
      const { isLoadingUpdater } = props;
      const userId = props.users.mydata.id;

      isLoadingUpdater(true);
      try {
        const result = await getShopOnboardingLink(userId);

        if (result instanceof Error || !result.onboarding_url) {
          notifyError(
            '口座登録の再開に失敗しました。時間をおいて再度お試しください'
          );
          return;
        }

        window.location.href = result.onboarding_url;
      } catch (error) {
        notifyError(
          '口座登録の再開に失敗しました。時間をおいて再度お試しください'
        );
      } finally {
        isLoadingUpdater(false);
      }
    },
  }),
  lifecycle({
    async componentDidMount() {
      this.props.isLoadingUpdater(true);
      await this.props.getMe();
      await this.props.getUserShop(this.props.users.mydata.id);
      this.props.isLoadingUpdater(false);
    },
  })
);

export default enhance;
